<div class="surface-card p-4 shadow-2 border-round">

    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">


        <div class="form_row" style="display: flex; flex-grow: 1; align-items: center">

            <div class="flex justify-end md:justify-center">
                <span class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">SCORTE SCUOLE</span>
            </div>
            <div class="flex justify-end md:justify-center" style="margin-left: 1em">
                <button pButton type="button" icon="pi pi-download" class="p-button-rounded mr-2 p-button-outlined" tooltipPosition="top" pTooltip="Scarica lista movimentazioni" (click)="downloadDataAsXlsx()" style="background-color: rgb(148, 121, 206); color: white;"></button>

            </div>
            <div style="flex-grow: 1"></div>

            <div class="form_row_item">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsScuole' [(ngModel)]="filterScuole" placeholder="scuola" (onChange)="updateFiltered()"></p-dropdown>
            </div>

            <div class="form_row_item">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsModelli' [(ngModel)]="filterModello" placeholder="dispositivo" (onChange)="updateFiltered()"></p-dropdown>
            </div>
        </div>

    </div>

    <div fxFlex="95%">

        <p-table #comuniDT styleClass="p-datatable-sm" [value]="filteredScorte" dataKey="id"
                 [selectionPageOnly]="true" [rowHover]="true" [rows]="30" [showCurrentPageReport]="true"
                 [rowsPerPageOptions]="[30,50,100]" [loading]="!dataReady" responsiveLayout="stack" [paginator]="true"
                 currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                 [globalFilterFields]="['','']" [sortField]="'balance'" [sortOrder]="1">

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="cui">
                        <div class="flex justify-content-between align-items-center">
                            Scuola
                            <p-sortIcon field="cui"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="nmu">
                        <div class="flex justify-content-between align-items-center">
                            Modello
                            <p-sortIcon field="nmu"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="balance">
                        <div class="flex justify-content-between align-items-center">
                            Quantità
                            <p-sortIcon field="balance"></p-sortIcon>
                        </div>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
                <tr>

                    <td>
                        <span class="text-lowercase">
                        {{ row.cui }}
                        </span>
                    </td>
                    <td>
                        <span class="text-lowercase">
                            {{ row.nmu }}:
                            {{ modelliById[row.rif_modello].descrizione }}
                        </span>
                    </td>
                    <td><span class="text-lowercase">
                            {{ row.balance }}
                    </span></td>

                </tr>
            </ng-template>

        </p-table>

    </div>
</div>

<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"></p-confirmDialog>

<p-toast position="top-center"></p-toast>
